(function () {
  'use strict';

  angular
    .module('eclipseApp.core')
    .directive('fidoSpinner', function () {
      return {
        restrict: 'EA',
        templateUrl: 'modules/core/spinner/spinner.view.html',
        scope: {
          color: '@'
        },
        link: function ($scope) {
          $scope.color = ($scope.color) ? $scope.color : '#000';
        }
      };
    });
})();
